// extracted by mini-css-extract-plugin
export default {"header":"workflow_page-module___header___a36dfc33"};